/** Shrinks a `btn-*` button to the profile's small size, with room for a leading icon. */
export const smallButton =
  "items-center gap-1.5 px-3 py-1.5 text-xs font-semibold";
